import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import classes from '../Assist.css';

import axios from 'axios';
import Alert from 'react-s-alert';

import { useMobile, authEndpoint, alertErrors } from '../../../store/utility';

class PasswordReset extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            passwordResetSucceeded: false
        }

        /* 1. Initialize Input Ref */
        this.passwordInput = React.createRef();
        this.confirmPasswordInput = React.createRef();

    }

    handleSet = () => {
        let url = authEndpoint + 'api/v1/rest-auth/password/reset/confirm/';
            let requestPasswordResetData = {
                uid: this.props.match.params.uid,
                token: this.props.match.params.token,
                new_password1: this.passwordInput.current.value,
                new_password2: this.confirmPasswordInput.current.value
            }
            axios.post(url, requestPasswordResetData)
                .then(response => {
                    Alert.info(response.data.detail);
                    this.setState({passwordResetSucceeded: true});
                })
                .catch(err => {
                    alertErrors(err);
        });
    }

    handleSuccess = () => {
        window.location = '/auth/login/';
    }

    handleRequestCode = () => {
        window.location = '/assist/request_password_reset/';
    }

    render(){

        let displaySize;
        if (useMobile()===true) {
            displaySize = 'none';
        }
        else {
            displaySize = 'none';
        }

        let passwordResetView;
        if (this.state.passwordResetSucceeded === false) {
            passwordResetView = (
                <div>
                <Row>
                <Col>
                    <div className={classes.Title}>
                        Reset Password
                    </div>
                </Col>
                </Row>
                <Row>
                <Col>
                    <Form.Group controlId="password">
                        <Form.Control ref={this.passwordInput} size={displaySize} type="password" placeholder="new password" defaultValue={this.props.email}/>
                    </Form.Group>
                </Col>
                </Row>
                <Row>
                <Col>
                    <Form.Group controlId="confirmPassword">
                        <Form.Control ref={this.confirmPasswordInput} size={displaySize} type="password" placeholder="confirm new password" defaultValue={this.props.email}/>
                    </Form.Group>
                </Col>
                </Row>
                <Row>
                    <Col lg={6} md={12}>
                        <div className={classes.Button}>
                        <Button variant="info" size={displaySize} onClick={this.handleSet} block>Change Password</Button>
                        </div>
                    </Col>
                    <Col lg={6} md={12}>
                        <div className={classes.Button}>
                        <Button variant="outline-info" size={displaySize} onClick={this.handleRequestCode} block>Request My Code</Button>
                        </div>
                    </Col>
                </Row>
                </div>
            )
        }
        else {
            passwordResetView = (
                <div>
                <Row>
                    <Col>
                        <div className={classes.Title}>
                        You have reset your password sucessfully!
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={6} md={12}>
                        <div className={classes.Button}>
                        <Button variant="info" size={displaySize} onClick={this.handleSuccess} block>Sign In Again</Button>
                        </div>
                    </Col>
                </Row>
                </div>
            )
        }

        return (

            <div className={classes.Assist}>
                <Container>
                    {passwordResetView}
                </Container>
            </div>
        );
    }
}

export default PasswordReset;


// WEBPACK FOOTER //
// ./src/containers/Assist/PasswordReset/PasswordReset.js